import React, { Component } from "react";
import { BrowserRouter, Route, Switch } from "react-router-dom";

import Backgrounds from "./backgrounds";

import Home from "./components/Home";
import GiftCard from "./components/GiftCard";
import Brands from "./components/Brands";
import WithHeader from "./components/WithHeader";
import PressReleases from "./components/PressReleases";
import About from "./components/About";
import FAQ from "./components/FAQ";
import Stories from "./components/Stories";

import "./css/main.css";
import "./imports";

import { GOOGLE_PLACE_ID } from "./config";

const RouteWithHeader = (props) => {
  const { Component } = props;
  return (
    <Route
      {...props}
      render={() => {
        return (
          <WithHeader {...props}>
            <Component {...props} />
          </WithHeader>
        );
      }}
    />
  );
};

class App extends Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  componentDidMount() {
    let request = {
        placeId: GOOGLE_PLACE_ID,
        fields: [
          "name",
          "rating",
          "review",
          "opening_hours",
          "formatted_phone_number",
          "formatted_address",
          "photo",
          "geometry",
        ],
      },
      googleClient = new window.google.maps.places.PlacesService(
        document.getElementById("render")
      );

    googleClient.getDetails(request, (place, status) => {
      this.setState({
        place: place || {},
      });
    });
  }

  render() {
    return (
      <React.Fragment>
        <div id='render' />
        <BrowserRouter>
          <Switch>
            <Route
              exact
              path='/'
              render={(props) => {
                return <Home {...this.state} {...props} />;
              }}
            />
            <Route
              exact
              path='/home'
              render={(props) => {
                return <Home {...this.state} {...props} />;
              }}
            />
            <RouteWithHeader
              {...this.state}
              title='Gift Cards'
              exact
              path='/giftcards'
              Component={GiftCard}
              bannerImg={Backgrounds.BrandsHeader}
            />
            <RouteWithHeader
              exact
              path='/brands'
              bannerImg={Backgrounds.BrandsHeader}
              title='Brands'
              Component={Brands}
              {...this.state}
            />
            <RouteWithHeader
              exact
              path='/press'
              bannerImg={Backgrounds.BrandsHeader}
              title='Press'
              Component={PressReleases}
              {...this.state}
            />
            <RouteWithHeader
              exact
              path='/about'
              bannerImg={Backgrounds.BrandsHeader}
              title='About us'
              Component={About}
              {...this.state}
            />
            <RouteWithHeader
              exact
              path='/faq'
              bannerImg={Backgrounds.BrandsHeader}
              title='FAQ'
              Component={FAQ}
              {...this.state}
            />
            <RouteWithHeader
              exact
              path='/story'
              bannerImg={Backgrounds.BrandsHeader}
              title='Story'
              Component={Stories}
              {...this.state}
            />
          </Switch>
        </BrowserRouter>
      </React.Fragment>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js